import { render, staticRenderFns } from "./indexHistoriaMenstrualShow.vue?vue&type=template&id=7889f112"
import script from "./indexHistoriaMenstrualShow.vue?vue&type=script&lang=js"
export * from "./indexHistoriaMenstrualShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports